import React from "react";
import { useState } from "react";
import { Link } from "react-router-dom";

const CreateLinkedInPage = () => {
  return (
    <div className="bg-[#F3F2EF] mt-14">
      <div className="container mx-auto flex flex-col lg:flex-row py-8 gap-4 px-4 sm:px-6 lg:px-8">
        <div className="min-h-screen bg-gray-100 flex flex-col items-center py-10">
          {/* Header */}
          <div className="text-center mb-10">
            <h1 className="text-4xl font-bold text-gray-800 mb-4">Create a LS LinkedIn Page</h1>
            <p className="text-gray-600">
              Connect with clients, employees, and the LS LinkedIn community. To get started, choose a page type.
            </p>
          </div>

          {/* Card Options */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
            {/* Card 1 */}
            <Link to="/company/setup-page/create-company-page">
              <div className="bg-white p-6 rounded-lg shadow-md flex flex-col items-center transform transition duration-100 hover:scale-[1.01] hover:shadow-lg hover:outline-2 hover:outline-blue-500">
                <div className="w-16 h-16 bg-blue-100 mb-4 flex items-center justify-center rounded-full">
                  <svg
                    className="w-8 h-8 text-blue-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h-4m-6 0H5m4-4h6"
                    ></path>
                  </svg>
                </div>
                <h3 className="text-lg font-semibold text-gray-800">Company</h3>
                <p className="text-gray-500 text-center">Small, medium, and large businesses</p>
              </div>
            </Link>
            {/* Card 2 */}
            <Link to="/business/company/createLinkedInPage/company">
              <div className="bg-white p-6 rounded-lg shadow-md flex flex-col items-center transform transition duration-100 hover:scale-[1.01] hover:shadow-lg hover:outline-2 hover:outline-blue-500">
                <div className="w-16 h-16 bg-green-100 mb-4 flex items-center justify-center rounded-full">
                  <svg
                    className="w-8 h-8 text-green-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
                    ></path>
                  </svg>
                </div>
                <h3 className="text-lg font-semibold text-gray-800">Showcase page</h3>
                <p className="text-gray-500 text-center">Sub-pages associated with an existing page</p>
              </div>
            </Link>
            {/* Card 3 */}
            <Link to="/business/company/createLinkedInPage/company">
              <div className="bg-white p-6 rounded-lg shadow-md flex flex-col items-center transform transition duration-100 hover:scale-[1.01] hover:shadow-lg hover:outline-2 hover:outline-blue-500">
                <div className="w-16 h-16 bg-purple-100 mb-4 flex items-center justify-center rounded-full">
                  <svg
                    className="w-8 h-8 text-purple-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M12 14l9-5-9-5-9 5 9 5zm0 7l-9-5 9-5 9 5-9 5z"
                    ></path>
                  </svg>
                </div>
                <h3 className="text-lg font-semibold text-gray-800">Educational institution</h3>
                <p className="text-gray-500 text-center">Schools and universities</p>
              </div>
            </Link>
          </div>

          {/* Mockup */}
          <div className="flex items-center justify-center">
            <img className="w-[50%] h-auto" src="/Images/business/company/desktop-mobile.png" alt="Mockup" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateLinkedInPage;